import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'

// evertel
import { Col, Row, Text } from '@evertel/web/ui'
import { ProfilePic } from '@evertel/web/user'
import { RoomContext } from '../RoomContext'

const EnabledConnectorsList: React.FC = observer(() => {

    const { roomConnectorsController } = useContext(RoomContext)

    if (roomConnectorsController.enabledConnectors.length === 0) return null

    return (
        <div className="mb-3">
            <Text bold className="mb-2">
                Enabled Connectors:
            </Text>
            {roomConnectorsController.enabledConnectors.map(connector => (
                <Row key={connector.id} className="align-items-center py-2">
                    <ProfilePic
                        userId={connector.integrationUserId}
                        className="connector-icon me-3"
                        width={30}
                        height={30}
                    />
                    <Col>
                        <Text color="muted" bold>{connector.name}</Text>
                        {/* <Text>{connector.description}</Text> */}
                    </Col>
                </Row>
            ))}
        </div>
    )
})

EnabledConnectorsList.displayName = 'EnabledConnectorsList'

export { EnabledConnectorsList }
